import React from "react";
import { MessageCircle, CheckCircle, Heart, Bell, Users } from "lucide-react";

const SixTab = () => {
  return (
    <div className="mx-auto p-6 bg-white-50 min-h-screen">
      {/* Header Section */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Emotional Wellness Modules
        </h1>
        <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
          Support that adapts to her journey—guided care, live therapy, and
          gentle daily check-ins.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button className="bg-green-700 hover:bg-green-800 text-white px-8 py-3 rounded-full font-semibold transition-colors duration-200">
            Start Your Wellness Path
          </button>
          <button className="border-2 border-green-700 text-green-700 hover:bg-green-50 px-8 py-3 rounded-full font-semibold transition-colors duration-200">
            Learn More
          </button>
        </div>
      </div>

      {/* Top 3 Features Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
        {/* Live Therapy Sessions */}
        <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200">
          <div className="flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4 mx-auto">
            <div className="relative">
              <div className="w-8 h-8 bg-green-600 rounded-full"></div>
              <MessageCircle className="absolute -top-1 -right-1 w-4 h-4 text-green-700" />
            </div>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">
            Live therapy sessions with certified counsellors
          </h3>
          <p className="text-gray-600 text-center">
            Book 1-on-1 video sessions with licensed experts.
          </p>
        </div>

        {/* Personalized Therapy Paths */}
        <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200">
          <div className="flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4 mx-auto">
            <div className="relative">
              <div className="w-6 h-1 bg-green-600 rounded-full mb-1"></div>
              <div className="w-4 h-1 bg-green-400 rounded-full mb-1 ml-1"></div>
              <CheckCircle className="w-6 h-6 text-green-600" />
            </div>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">
            Personalized therapy paths and weekly updates
          </h3>
          <p className="text-gray-600 text-center">
            A plan that adjusts to progress and feedback.
          </p>
        </div>

        {/* Mood Tracking */}
        <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200">
          <div className="flex items-center justify-center w-16 h-16 bg-pink-100 rounded-full mb-4 mx-auto">
            <div className="relative">
              <Heart className="w-8 h-8 text-pink-400" />
              <CheckCircle className="absolute -bottom-1 -right-1 w-4 h-4 text-green-600" />
            </div>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">
            Mood tracking, guided journaling, mindfulness routines
          </h3>
          <p className="text-gray-600 text-center">
            Daily mood logs, prompts, and calm practices.
          </p>
        </div>
      </div>

      {/* Bottom 2 Boxes (Centered on Web) */}
      <div className="flex flex-col lg:flex-row justify-center items-stretch gap-8 mb-12">
        {/* Crisis Alert System */}
        <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 w-full lg:w-1/3">
          <div className="flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4 mx-auto">
            <Bell className="w-8 h-8 text-green-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">
            Crisis alert system and red-flag escalation
          </h3>
          <p className="text-gray-600 text-center">
            Smart alerts nudge timely support when needed.
          </p>
        </div>

        {/* Support Groups */}
        <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 w-full lg:w-1/3">
          <div className="flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4 mx-auto">
            <Users className="w-8 h-8 text-green-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">
            Stage-based support groups and survivor communities
          </h3>
          <p className="text-gray-600 text-center">
            Peers by diagnosis stage for safe sharing.
          </p>
        </div>
      </div>

      {/* Trust Indicators */}
      <div className="text-center mb-8">
        <div className="flex flex-wrap justify-center items-center gap-8 text-gray-600 text-lg">
          <span className="flex items-center gap-2">
            <div className="w-2 h-2 bg-green-600 rounded-full"></div>
            HIPAA-aligned
          </span>
          <span className="flex items-center gap-2">
            <div className="w-2 h-2 bg-green-600 rounded-full"></div>
            Private & Secure
          </span>
          <span className="flex items-center gap-2">
            <div className="w-2 h-2 bg-green-600 rounded-full"></div>
            Human-in-the-loop care
          </span>
        </div>
      </div>

      {/* Bottom CTA */}
      <div className="text-center">
        <button className="bg-green-700 hover:bg-green-800 text-white px-8 py-3 rounded-full font-semibold text-lg transition-colors duration-200 shadow-lg hover:shadow-xl">
          Take a 2-min Mood Check
        </button>
      </div>
    </div>
  );
};

export default SixTab;
